import { ResonanceAudio } from 'resonance-audio';

export const ROOM_MATERIALS: { label: string, value: string }[] = [
    { label: 'Bare brick', value: 'brick-bare' },
    { label: 'Coarse concrete block', value: 'concrete-block-coarse' },
    { label: 'Fiber glass insulation', value: 'fiber-glass-insulation' },
    { label: 'Heavy curtain', value: 'curtain-heavy' },
    { label: 'Linoleum on concrete', value: 'linoleum-on-concrete' },
    { label: 'Marble', value: 'marble' },
    { label: 'Metal', value: 'metal' },
    { label: 'Painted brick', value: 'brick-painted' },
    { label: 'Painted concrete block', value: 'concrete-block-painted' },
    { label: 'Parquet on concrete', value: 'parquet-on-concrete' },
    { label: 'Plywood panel', value: 'plywood-panel' },
    { label: 'Polished concrete', value: 'polished-concrete-or-tile' },
    { label: 'Smooth plaster', value: 'plaster-smooth' },
    { label: 'Thick glass', value: 'glass-thick' },
    { label: 'Thin glass', value: 'glass-thin' },
    { label: 'Wood panel', value: 'wood-panel' }
];

let audioContext: AudioContext | null = null;;
let scene: any;
let sSrc: any;

export function init() {
    audioContext = new AudioContext();

    scene = new ResonanceAudio(audioContext);
    scene.output.connect(audioContext.destination);

    sSrc = scene.createSource();
    sSrc.setPosition(0, 0, 0);
}

export async function start() {
    if (!audioContext) init();
    audioContext!.resume();
    let stream = await requestMicrophoneStream();
    let src = audioContext!.createMediaStreamSource(stream);
    src.connect(sSrc.input);
}

export function setRoom([width, height, depth]: [width: number, height: number, depth: number], material: string) {
    if (!scene) init();
    scene.setRoomProperties(
        { width, height, depth },
        { left: material, right: material, front: material, back: material, down: material, up: material }
    );
}

export function setListenerPosition([x, y, z]: [x: number, y: number, z: number]) {
    if (!scene) init();
    scene.setListenerPosition(x, y, z);
}

async function requestMicrophoneStream(): Promise<MediaStream> {
    if (navigator.mediaDevices) {
        return await navigator.mediaDevices.getUserMedia({
            audio: true,
            video: false
        });
    } else {
        return await new Promise<MediaStream>((res, rej) =>
            navigator.getUserMedia({ audio: true, video: false }, res, rej)
        );
    }
}